<!-- Divider -->
<div
    class="hippo-vertical-navigation-item-wrapper divider"
    [ngClass]="item.classes?.wrapper"></div>
